import { rivermeadowApi } from './api';

// User customizations API endpoints
export const userCustomizationsApi = rivermeadowApi.injectEndpoints({
    endpoints: (builder) => ({
        getUserCustomization: builder.query({
            query: (orgId) => ({
                url: `user-customizations/organizations/${orgId}`,
                method: 'GET',
            }),
            providesTags: ['USER_CUSTOMIZATIONS'],
            transformResponse: (response) => {
                // If API returns the full structure, use it
                if (response?.discovery?.inventory_table) {
                    return response;
                }
                // Otherwise, return null to use defaults
                return null;
            },
        }),
        saveUserCustomization: builder.mutation({
            query: ({ orgId, customization }) => ({
                url: `user-customizations/organizations/${orgId}`,
                method: 'POST',
                body: customization,
            }),
            invalidatesTags: ['USER_CUSTOMIZATIONS'],
        }),
    }),
});

export const { useGetUserCustomizationQuery, useLazyGetUserCustomizationQuery, useSaveUserCustomizationMutation } =
    userCustomizationsApi;
